import { NavLink } from "react-router-dom";
import logo from "../images/owl.svg";
import "../styles/general.css";
import "../styles/LandingPageHeader.css";

function LandingPageHeader() {
  return (
    <div className="nav-container-alt">
      <div className="nav-alt">
        <div className="logo-container-alt">
          <img src={logo} className="logo-alt" alt="logo" />
          <span className="logo-text-alt"> ezHabit</span>
        </div>
        <nav className="nav-list-alt">
          <NavLink
            to="/blogs"
            className={({ isActive }) =>
              isActive ? "nav-link-alt hover-underline-animation-alt active" : "nav-link-alt hover-underline-animation-alt"
            }
          >
            Blogs
          </NavLink>
          <NavLink
            to="/app"
            className={({ isActive }) => {
              return isActive ? "nav-link-alt hover-underline-animation-alt active" : "nav-link-alt hover-underline-animation-alt";
            }}
          >
            Go to App
          </NavLink>
        </nav>
      </div>
    </div>
  );
}

export default LandingPageHeader;
